import { render } from "./CreatePoll.vue?vue&type=template&id=1c715e9e&scoped=true"
import script from "./CreatePoll.vue?vue&type=script&lang=js"
export * from "./CreatePoll.vue?vue&type=script&lang=js"

import "./CreatePoll.vue?vue&type=style&index=0&id=1c715e9e&scoped=true&lang=css"

import exportComponent from "/home/computacionucat/ucat-evaluacion-desempeno-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c715e9e"]])

export default __exports__